<template lang="pug">
.dialog-wrapper.flex-mid(v-if="show", @touchmove.prevent)
  .dialog-body
    .title 领取成功
    .content
      slot
    .operation
      .btn.primary.flex-mid(@click="$emit('ok')") {{ isApp ? '去骑行' : '去App骑行' }}
      .btn.flex-mid(@click="$emit('cancel')") 稍后再去
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default:
        '恭喜您成功领取到APP随机立减福利，骑单车首单最高可享免单，快去哈啰APP享受优惠出行吧',
    },
  },
  data() {
    return {
      isApp: env.isEasyBikeApp,
    };
  },
  methods: {},
};
</script>

<style scoped lang="less">
.dialog-wrapper {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.7);

  .dialog-body {
    padding: 0.27rem 0.16rem 0.22rem;
    width: 3.2rem;
    // height: 1.85rem;
    background: #fff;
    border-radius: 0.12rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .red {
      color: red;
    }

    .title {
      font-size: 0.18rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
    }

    .content {
      font-size: 0.14rem;
      color: #5a6066;
      line-height: 0.2rem;
      text-align: center;
      margin-top: 0.12rem;
      margin-bottom: 0.1rem;
    }

    .operation {
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex-direction: column;

      .btn {
        width: 100%;
        height: 0.48rem;
        border-radius: 0.08rem;
        border: 0.01rem solid #08f;
        font-size: 0.18rem;
        color: #0081f1;
        line-height: 0.25rem;

        &:not(:last-of-type) {
          margin-bottom: 0.09rem;
        }

        &.primary {
          color: #fff;
          background: #08f;
          border: none;
        }
      }
    }
  }
}
</style>
